'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const DataDogRumInit = () => {

useEffect(() => {
  // window is accessible here.
  if(!datadogRum.getInitConfiguration()?.applicationId){
    datadogRum.init({
      applicationId: window.globalConfig?.DATADOG?.APPLICATION_ID,
      clientToken: window.globalConfig?.DATADOG?.CLIENT_TOKEN,
      // `site` refers to the Datadog site parameter of your organization
      // see Getting Started with Datadog Sites 
      site: 'datadoghq.com',
      service: window.globalConfig?.DATADOG?.SERVICE,
      env: window.globalConfig?.DATADOG?.ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0', 
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
    });
  }
 }, []);

 return <></>
};

export default DataDogRumInit;